import { Fragment, ShareButtons } from '../../../components'

const SectionShare = ({ constituency, signup, fragments }) => {
  return (
    <>
      <Grid item xs={12} sm={8} md={6} style={{ padding: '0 20px' }}>
        <Typography variant="h5" style={{ color: 'white' }} align="center">
          <Fragment title="results_share_title" fragments={fragments} />
        </Typography>
        <Typography
          variant="body1"
          style={{
            color: 'white',
            paddingBottom: fragments['results_share_content']?.content ? 30 : 0,
          }}
        >
          <Fragment title="results_share_content" fragments={fragments} />
        </Typography>
        <ShareButtons {...{ constituency, signup }} />
      </Grid>
    </>
  )
}

export default SectionShare
